import React, { useState, useCallback } from "react";
import "./styles.css";

// Resolve API base dynamically
const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  (window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : window.location.origin);

function LoginPage() {
  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleLogin = useCallback(() => {
    if (isRedirecting) return;
    setIsRedirecting(true);
    // Small delay so the spinner is visible
    setTimeout(() => {
      window.location.href = `${API_BASE}/login`;
    }, 150);
  }, [isRedirecting]);

  return (
    <div className="login-wrap">
      <div className="login-blob a" />
      <div className="login-blob b" />

      <div className="login-shell" role="main" aria-labelledby="login-title">
        <div className="login-brand">
          {/* Replace with your logo if you have one */}
          <div className="brand-mark brand-z" aria-hidden="true">Z</div>
          <div className="brand-text">
            <h1 id="login-title" className="login-title">Zoom予約システム</h1>
            <p className="login-subtext">Googleアカウントでログインしてください</p>
          </div>
        </div>

        <button
          className={`google-login-btn2 ${isRedirecting ? "loading" : ""}`}
          onClick={handleLogin}
          disabled={isRedirecting}
          aria-busy={isRedirecting}
          aria-disabled={isRedirecting}
        >
          {!isRedirecting ? (
            <>
              <GoogleIcon />
              <span>Googleでログイン</span>
            </>
          ) : (
            <>
              <Spinner />
              <span>リダイレクト中…</span>
            </>
          )}
        </button>

        <div className="login-foot">
          <p className="disclaimer">
            ログインすることで、<span className="nowrap">Googleの認証</span>を使用して本人確認を行います。
          </p>
        </div>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg
      className="g-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 48 48"
      aria-hidden="true"
      focusable="false"
    >
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.6 32.6 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.7 1.1 7.7 3l5.7-5.7C34.2 6.1 29.4 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c10.4 0 19-8.4 19-19 0-1.3-.1-2.2-.4-3.5z"/>
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 18.9 12 24 12c3 0 5.7 1.1 7.7 3l5.7-5.7C34.2 6.1 29.4 4 24 4 15.5 4 8.5 8.8 6.3 14.7z"/>
      <path fill="#4CAF50" d="M24 44c5.1 0 9.9-1.9 13.5-5.1l-6.2-5.1C29.2 36 26.8 37 24 37c-5.1 0-9.5-3.4-11.1-8.1l-6.6 5.1C8.5 39.2 15.5 44 24 44z"/>
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-1.3 3.6-4.7 6-8.3 6-5.1 0-9.5-3.4-11.1-8.1l-6.6 5.1C8.5 39.2 15.5 44 24 44c10.4 0 19-8.4 19-19 0-1.3-.1-2.2-.4-3.5z"/>
    </svg>
  );
}

function Spinner() {
  return <span className="spinner" aria-hidden="true" />;
}

export default LoginPage;
